import Jumbotron from './Jumbotron'
import enhance from './Jumbotron.enhancer'

export default enhance(Jumbotron)
